import tampuuriWindowObject from "../../tampuuriWindowObject";
import useCdn from "./useCdn.jsx";

const useHelpers = () => {
  /**
   * Checks if node is in array
   * @param {*} node
   * @param {*} array
   * @returns
   */
  const checkForChecked = (node, array) => {
    if (array.includes(node)) {
      return true;
    }
    return false;
  };

  /**
   * Construct HREF with params
   * @param {*} params
   * @param {*} url
   * @returns
   */
  const constructHref = (params, url) => {
    const base = url ? url : window.location.origin + window.location.pathname;
    const baseUrl = new URL(base);

    if (Array.isArray(params?.locations) && params.locations.length > 0) {
      params.locations.forEach(function (i, idx) {
        baseUrl.searchParams.append("location", i);
      });
    }

    if (Array.isArray(params?.extraInfos) && params.extraInfos.length > 0) {
      params.extraInfos.forEach(function (i, idx) {
        baseUrl.searchParams.append("extraInfo", i);
      });
    }

    if (Array.isArray(params?.rentalTypes) && params.rentalTypes.length > 0) {
      params.rentalTypes.forEach(function (i, idx) {
        baseUrl.searchParams.append("rentalType", i);
      });
    }

    if (Array.isArray(params?.priceLevels) && params.priceLevels.length > 0) {
      params.priceLevels.forEach(function (i, idx) {
        baseUrl.searchParams.append("priceLevel", i);
      });
    }

    if (params?.rent) {
      baseUrl.searchParams.append("rent", params.rent);
    }

    if (params?.surfaceArea) {
      baseUrl.searchParams.append("surface-area", params.surfaceArea);
    }

    if (params?.exchangeStudents) {
      baseUrl.searchParams.append("exchangeStudents", params.exchangeStudents);
    }

    if (params?.setFirstPage) {
      //If filters change --> change page to 1
      params.page = 1;
    }

    if (params?.page) {
      baseUrl.searchParams.append("page", params.page);
    }

    return baseUrl;
  };

  /**
   * Get image by priority
   * @param {*} images
   * @param {*} priority
   * @returns
   */
  const getImageByPriority = (images, priority = "is_primary") => {
    let foundImage = null;

    images.forEach((image) => {
      //If room or apartment --> use is_primary
      if (image[priority] !== undefined) {
        foundImage = image;
        return;
      }
    });

    if (foundImage) {
      return foundImage;
    }

    switch (priority) {
      case "is_primary":
        return getImageByPriority(images, "is_facade");
      case "is_facade":
        return getImageByPriority(images, "fall_back_to_default");
      default:
        return null;
    }
  };

  /**
   * Returns default image src
   * @param {*} defaultImage
   * @returns
   */
  const getDefaultImageSrc = (defaultImage) => {
    const { sizes } = defaultImage || {};
    const url =
      sizes && sizes["hoas-image-size-large"]
        ? sizes["hoas-image-size-large"]
        : image["url"] !== undefined
          ? image["url"]
          : null;
    return url;
  };

  /**
   * Get cost-unit algolia facade image
   * @param {*} costUnit
   * @returns
   */
  const getCostUnitImage = async (costUnit) => {
    const { images } = costUnit || {};
    const { cdnImage } = useCdn();

    const image = getImageByPriority(images, "is_facade");
    if (image && image["path"] !== undefined) {
      return await cdnImage("carousel", image["path"]);
    }
    const { getDefaultImageCostUnit } = tampuuriWindowObject();
    const defaultImage = getDefaultImageCostUnit();
    return Promise.resolve(getDefaultImageSrc(defaultImage));
  };

  /**
   * Get image for apartment card
   * Priority:
   * 1. Apartment is_primary image
   * 2. Apartment is_facade image
   * 3. CostUnit is_facade image
   * 4. Default apartment image
   * @param {*} apartment
   * @returns
   */
  const getApartmentImage = async (apartment) => {
    const { images } = apartment || {};
    const { cdnImage } = useCdn();
    const apartmentImage = getImageByPriority(images, "is_primary");
    if (apartmentImage && apartmentImage["path"] !== undefined) {
      return await cdnImage("carousel", apartmentImage["path"]);
    }
    const { getDefaultImageApartment } = tampuuriWindowObject();
    const defaultImage = getDefaultImageApartment();
    return Promise.resolve(getDefaultImageSrc(defaultImage));
  };

  return {
    checkForChecked: checkForChecked,
    constructHref: constructHref,
    getCostUnitImage: getCostUnitImage,
    getApartmentImage: getApartmentImage,
  };
};
export default useHelpers;
